module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_dac_en.cc5a829dcf8264c4f3dd5a84f7a7e731.png";